import { useAudio } from "@aircall/tractor";
import { useCallback } from "react";
import { useAutoScrollState } from "../useAutoScrollState/useAutoScrollState";

export const useSeekAndScroll = (startTime: number) => {
  const { seek, play } = useAudio();
  const { activate } = useAutoScrollState();

  const seekAndScroll = useCallback(() => {
    activate();
    seek(startTime);
    play();
  }, [activate, seek, startTime, play]);

  return { seekAndScroll };
};
